/**分页配置
 * defaultPage: 默认页数(1)
 * defaultPageSize 默认条数(10)
 */
 export default {
  defaultPage: 1,
  defaultPageSize: 10
}